import { apiRequest, investmentEntityRequest } from '@utils/request';
import { InvestorUpdateView } from 'types/account';
import { useAppStore } from '@stores/app';

/**
 * Get an investor update detail view by ID
 */
export async function getInvestorUpdateView(investorUpdateId: string): Promise<InvestorUpdateView> {
	const appStore = useAppStore();
	const response = appStore.isAuthenticated
		? await investmentEntityRequest.get(`/investor-update/${investorUpdateId}/view`, { suppressToast: () => true })
		: await apiRequest.get(`/investor-update/${investorUpdateId}/view`, { suppressToast: () => true });

	return response.data;
}
